import { fetchWithRetry } from '@/utils';

export const me = async () =>
  fetchWithRetry('/api/v2/call', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      action: 'me',
    }),
  })
    .then(res => res.json())
    .then(res => res.result);
